import { Image, Keyword } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Selective } from "@siteimprove/alfa-selective";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
/**
 * @internal
 */
export const parse = either(Keyword.parse("none"), Image.parse);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-image-source}
 * @internal
 */
export default Longhand.of(Keyword.of("none"), parse, (value, style) => value.map((image) => Selective.of(image)
    .if(Image.isImage, (image) => image.partiallyResolve(Resolver.length(style)))
    .get()));
//# sourceMappingURL=border-image-source.js.map